export const TAG_EDIT_ACTIONS = {
  EDIT: "EDIT",
  DELETE: "DELETE",
  RESET: "RESET",
};
